<template>
  <svg
    viewBox="0 0 50 50"
    class="zo-spinner"
    :qa-id="`${qaId}_icon`"
  >
    <circle
      class="ring"
      cx="25"
      cy="25"
      r="22.5"
    />
    <circle
      class="line"
      cx="25"
      cy="25"
      r="22.5"
    />
  </svg>
</template>

<script>
export default {
  props: {
    qaId: {
      type: String,
      default: 'spinner',
    },
  },
};
</script>

<style lang="scss">
.zo-spinner {
  --spinner-size: var(--local-spinner-size, 1.334);
  --line-color: var(--local-spinner-line-color, var(--brand-base));
  --line-alpha: var(--local-spinner-line-alpha, 1);
  --ring-color: var(--local-spinner-ring-color, var(--brand-base));
  --ring-alpha: var(--local-spinner-ring-alpha, 0.1);
  --ring-size: var(--local-spinner-ring-size, 10);

  font-size: calc(var(--spinner-size) * 1em);
  width: 1em;
  height: 1em;
  border-radius: 50%;
  vertical-align: bottom;

  .line {
    fill: none;
    stroke: var(--line-color);
    stroke-width: var(--ring-size);
    opacity: var(--line-alpha);
    stroke-linecap: round;
    transform-origin: 50% 50%;
    transform: rotate3d(0, 0, 1, 0deg);
    animation: 2156ms spinner-arc ease-in-out infinite, 1829ms spinner-rotate linear infinite;
  }

  .ring {
    fill: none;
    stroke: var(--ring-color);
    stroke-width: var(--ring-size);
    opacity: var(--ring-alpha);
  }
}

@keyframes spinner-rotate {
  to {
    transform: rotate3d(0, 0, 1, 360deg);
  }
}

@keyframes spinner-arc {
  from {
    stroke-dasharray: 0 150;
    stroke-dashoffset: 0;
  }
  to {
    stroke-dasharray: 100 150;
    stroke-dashoffset: -140;
  }
}
</style>
